/**
 * Hand a generated file to the browser.
 *
 * Small enough to inline, but it is needed from two places now — the offering
 * page and the assistant transcript — and the awkward parts (Firefox wanting
 * the anchor in the document, Safari wanting the object URL to outlive the
 * click) are exactly the kind of detail that gets fixed in one copy and not
 * the other.
 */
export function downloadTextFile(
  content: string,
  fileName: string,
  mimeType = 'text/plain;charset=utf-8',
): void {
  const url = URL.createObjectURL(new Blob([content], { type: mimeType }));

  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  // Firefox only honours a synthetic click on an anchor that is in the
  // document; revoking is deferred so the download still has the URL when it
  // starts.
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url));
}
